// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 合思支付插件配置表单项
 * @constructor
 */
const HosePayFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "channelCode"]}
        label={"ChannelCode"}
        placeholder={"请输入channelCode"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入channelCode"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "AESKey"]}
        label={"AESKey"}
        placeholder={"请输入AESKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入AESKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "publicRSAKey"]}
        label={"PublicRSAKey"}
        placeholder={"请输入publicRSAKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入publicRSAKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "privateRSAKey"]}
        label={"PrivateRSAKey"}
        placeholder={"请输入privateRSAKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入privateRSAKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "prePayFlowId"]}
        label={"PrePayFlowId"}
        placeholder={"请输入prePayFlowId"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入prePayFlowId"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "confirmFlowId"]}
        label={"ConfirmFlowId"}
        placeholder={"请输入confirmFlowId"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入confirmFlowId"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default HosePayFormItems
